function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ProductCardsGridDekstopComponent from "./product-cards-grid-dekstop-component.js";
import ProductCardsGridMobileComponent from "./product-cards-grid-mobile-component.js";
import DefaultProps from "./default-props";
import { StyledProductCardsGridComponent } from "./product-cards-grid-component.scss";
import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
const ProductCardsGridComponent = (props)=>{
    const { cards } = props;
    const productTypeMissing = ()=>{
        cards === null || cards === void 0 ? void 0 : cards.forEach((card, index)=>{
            const { productType } = card;
            if (!productType) {
                Sentry.captureMessage(`Product type is missing in card number: ${index}`);
            }
        });
    };
    useEffect(()=>{
        productTypeMissing();
    }, [
        cards
    ]);
    return /*#__PURE__*/ _jsxs(StyledProductCardsGridComponent, {
        className: "product-cards-grid-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "product-cards-grid-full-size-wrapper",
                children: /*#__PURE__*/ _jsx(ProductCardsGridDekstopComponent, _object_spread({}, props))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "product-cards-grid-small-size-wrapper",
                children: /*#__PURE__*/ _jsx(ProductCardsGridMobileComponent, _object_spread({}, props))
            })
        ]
    });
};
ProductCardsGridComponent.defaultProps = DefaultProps;
export default ProductCardsGridComponent;
